export function fmtPct(v: number | null | undefined): string {
  if (v === null || v === undefined) return '—'
  return `${(v * 100).toFixed(0)}%`
}

export function fmtMs(v: number): string {
  return `${Math.round(v)} ms`
}

export function fmtCost(v: number): string {
  if (v === 0) return '$0'
  if (v < 0.0001) return `$${v.toExponential(1)}`
  return `$${v.toFixed(5)}`
}

/** Input format: "2026-04-26T19-01-37Z" (the harness's filesystem-safe ISO). */
export function fmtTimestamp(iso: string): string {
  const restored = iso.replace(/T(\d{2})-(\d{2})-(\d{2})Z/, 'T$1:$2:$3Z')
  const date = new Date(restored)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  })
}
